<div class="table-shipping-name-wrapper">
    <div class="shipping-method">
      <img class="shipping-icon mr-12-px" src="./../../../../../assets/images/product/shipping/container.svg"
        alt="express-shipping">
      <span class="shipping-name">Free shipping</span>
    </div>

    <div class="shipping-duration">
      <div class="duration-in-days">{{deliveryInWeeksFrom}}-{{deliveryInWeeksTo}}</div>
      <div class="duration-text">weeks</div>

    </div>
  </div>